import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import i18n from './i18n';
import App from './App';
import reportWebVitals from './reportWebVitals';
import keycloak from './lib/keycloak';
import {AuthProvider} from './context/AuthContext';

// Keycloak MUST be initialised before React renders.
// With onLoad:'login-required', unauthenticated users are redirected to the
// Keycloak login page. On return, the adapter exchanges the auth code for
// tokens (PKCE + fragment mode) before React Router ever mounts, preventing
// the router from stripping the callback fragment from the URL.
keycloak
    .init({
        onLoad: 'login-required',
        checkLoginIframe: false,   // avoid 3rd-party cookie issues in modern browsers
        pkceMethod: 'S256',        // mandatory for public SPA clients
        responseMode: 'fragment',  // tokens returned in the URL hash, not query string
    })
    .then((authenticated) => {
        if (!authenticated) {
            // Defensive fallback — login-required already redirects, but guard here too.
            keycloak.login();
            return;
        }

        const root = ReactDOM.createRoot(document.getElementById('root'));
        root.render(
            <React.StrictMode>
                <AuthProvider keycloak={keycloak}>
                    <App/>
                </AuthProvider>
            </React.StrictMode>
        );
    })
    .catch((err) => {
        console.error('Keycloak init failed:', err);
        const root = ReactDOM.createRoot(document.getElementById('root'));
        root.render(
            <div style={{padding: '32px', fontFamily: 'sans-serif', textAlign: 'center'}}>
                <h2>{i18n.t('auth.keycloak.unavailable.title')}</h2>
                <p>{i18n.t('auth.keycloak.unavailable.description')}</p>
            </div>
        );
    });

reportWebVitals();
